// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_SalvaOrcamentoServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos_servicos/salvaOrcamentoServico
 *
 * Validates single service create/update within an orcamento.
 */
import { registerContract } from './validate'

export interface OrcamentosServicos_SalvaOrcamentoServicoInput {
orcamento_id: number
servico_id: number
servico_valor: number
orcamento_servico_id?: number
orcamento_servico_qtd?: number
orcamento_servico_user_id?: string
orcamento_servico_tipo?: number
orcamento_servico_status?: number
}

registerContract('OrcamentosServicos_SalvaOrcamentoServicoInput', {
  orcamento_id:              { type: 'number',  required: true },
  servico_id:                { type: 'number',  required: true },
  servico_valor:             { type: 'number',  required: true },
  orcamento_servico_id:      { type: 'number',  required: false },
  orcamento_servico_qtd:     { type: 'number',  required: false },
  orcamento_servico_user_id: { type: 'string',  required: false },
  orcamento_servico_tipo:    { type: 'number',  required: false },
  orcamento_servico_status:  { type: 'number',  required: false },
})
